export const apiConfig = {
  apiUrl: 'https://api.poko.com.pl'
};


